import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "components/index";
import { BrowserRouter } from "react-router-dom";
import { ContextProvider } from "Context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContextProvider>
        <App />
      </ContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);
